/**
 * Router 전용 utils
 */
const reg = /[\{\}\[\]\/?#]/gi;

export const convertTitle = (title: string) => {
  let rTitle = title;
  if (reg.test(title)) {
    rTitle = title.replace(reg, '');
  }
  rTitle = rTitle?.replace(/ /g, '-');
  return rTitle;
};

export const getEpisodeUrl = (comicId: number) => {
  // const cTitle = title === '' ? 'contentTitle' : encodeURI(convertTitle(title));
  return `/content/${comicId}`;
};

export const getViewerUrl = (comicId: number, episodeId: number) => {
  // const cTitle = title === '' ? 'contentTitle' : encodeURI(convertTitle(title));
  return `/content/${comicId}/${episodeId}`;
};

export const getPrologueViewerUrl = (comicId: number, title: string) => {
  const cTitle = title === '' ? 'contentTitle' : encodeURI(convertTitle(title));

  return `/comicprologue/${cTitle}/${comicId}`;
};

/**
 * 현재 호스트가 local 인지 아닌지 판단하는 함수
 */
export const isLocal = () => {
  const host = window.location.hostname;
  if (host.includes('localhost')) return true;
  return false;
};

// /**
//  * 호스트에 따라 path 변경
//  * @return local일때 path, 아닐때 /path
//  */
// export const convertUrl = (path: string) => {
//   return isLocal() ? path : `/${path}`;
// };
